// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"416":"971471f7","501":"90b99d61"}[chunkId] + ".chunk.js";
};